/*
Sohel 02/24/2023 3075154998 Added processor Group Table validation popup
Rohini 02/28/2023 3075154998 Added class name for the button
Phanee 02/28/2023 3075154998 rename pre-processor to Transformation Group in warning popup
*/
import React from 'react';
import {Button, Typography} from '@material-ui/core';
import reusableInputStyles from '../../../../../../components/InputStyles';
function ProcessorGroupValidationPopup({handleValidationClose}) {
  const classes = reusableInputStyles();
  return (
    <div>
      <div className={classes.dialoguecardStyles}>
        <div className="text-center my-3">
          <Typography variant="h4">
            {' '}
            Selected fields are not matching the Transformation Group that you are trying to select. Please
            select correct Transformation Group or add new one.
          </Typography>
        </div>
        <div className="button-table-spacing-mb new-standard-textfields">
          <Button
            type="button"
            variant="outlined"
            className={`ml-1 reset-btn`}
            onClick={() => {
              handleValidationClose();
            }}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
export default ProcessorGroupValidationPopup;
